import { TranslateService } from '@ngx-translate/core';
import { VariableApiError } from '@selfai-platform/pipeline-common';
import { isVariableError } from './type-guards.util';

export function extractVariableError(
  httpError: unknown,
  messageKey: string,
  translateService: TranslateService,
): VariableApiError {
  const errorBody = (httpError as { error?: unknown })?.error || httpError;

  if (isVariableError(errorBody)) {
    return errorBody;
  }

  return {
    code: 'UnknownError',
    details: {},
    id: Date.now().toString(),
    message: translateService.instant(messageKey),
    title: translateService.instant('workflow.variables.error.title'),
  };
}
